import React from "react";

import './index.css';

const PageLoader = () => <div className="loader"></div>;
export { PageLoader };